import React from 'react';
import { useMatches } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import Breadcrumb from './Breadcrumb';
function Breadcrumbs() {
    const matches = useMatches();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const crumbs = matches.filter((e) => !!e.handle?.crumb).map((e) => e.handle?.crumb(e.data));
    return (React.createElement(MuiBreadcrumbs, null, crumbs.map((items, i) => items.map((item, j) => (React.createElement(Breadcrumb, { key: `${i}-${j}`, label: item.label, link: item.link, icon: item.icon }))))));
}
export default Breadcrumbs;
